export const CLINIC_OPTIONS = {
  PRACTICE_NAME: "Practice.Name",
  PRACTICE_LOGO: "Practice.Logo",
  CLINIC_NAME: "Clinic.Name",
  CLINIC_FULL_ADDRESS: "Clinic.FullAddress",
  CLINIC_STREET_ADDRESS_LINE1: "Clinic.StreetAddressLine1",
  CLINIC_STREET_ADDRESS_LINE2: "Clinic.StreetAddressLine2",
  CLINIC_CITY: "Clinic.City",
  CLINIC_STATE: "Clinic.State",
  CLINIC_ZIP_CODE: "Clinic.ZIPCode",
  CLINIC_PHONE_NUMBER: "Clinic.PhoneNumber",
  CLINIC_EMAIL: "Clinic.Email",
  CLINIC_FAX_NUMBER: "Clinic.FaxNumber",
  CLINIC_GOOGLE_MAP_URL: "Clinic.GoogleMapURL",
  CLINIC_BUSINESS_NAME: "Clinic.BusinessName",
  PRACTICE_PORTAL_LINK: "Practice.PortalLink",
  // SN-19877 (Anvil parity)
  CLINIC_STREET_ADDRESS: "Clinic.StreetAddress",
  CLINIC_CITY_STATE_ZIP: "Clinic.CityStateZIP",
  CLINIC_BILLING_STREET_ADDRESS: "Clinic.Billing.StreetAddress",
  CLINIC_BILLING_CITY_STATE_ZIP: "Clinic.Billing.CityStateZIP",
  CLINIC_BILLING_FULL_ADDRESS: "Clinic.Billing.FullAddress",
  CLINIC_BILLING_PHONE_NUMBER: "Clinic.Billing.PhoneNumber",
  PRACTICE_NPI: "Practice.NPI"
};

export const CLINIC_MENU_OPTIONS = {
  title: "Clinic",
  menu: [
    {
      title: "Practice - Name",
      value: CLINIC_OPTIONS.PRACTICE_NAME
    },
    {
      title: "Practice - Logo",
      value: CLINIC_OPTIONS.PRACTICE_LOGO
    },
    {
      title: "Clinic - Name",
      value: CLINIC_OPTIONS.CLINIC_NAME
    },
    {
      title: "Clinic - Full Address",
      value: CLINIC_OPTIONS.CLINIC_FULL_ADDRESS
    },
    {
      title: "Clinic - Street Address Line 1",
      value: CLINIC_OPTIONS.CLINIC_STREET_ADDRESS_LINE1
    },
    {
      title: "Clinic - Street Address Line 2",
      value: CLINIC_OPTIONS.CLINIC_STREET_ADDRESS_LINE2
    },
    {
      title: "Clinic - City",
      value: CLINIC_OPTIONS.CLINIC_CITY
    },
    {
      title: "Clinic - State",
      value: CLINIC_OPTIONS.CLINIC_STATE
    },
    {
      title: "Clinic - ZIP Code",
      value: CLINIC_OPTIONS.CLINIC_ZIP_CODE
    },
    {
      title: "Clinic - Phone Number",
      value: CLINIC_OPTIONS.CLINIC_PHONE_NUMBER
    },
    {
      title: "Clinic - Email",
      value: CLINIC_OPTIONS.CLINIC_EMAIL
    },
    {
      title: "Clinic - Fax Number",
      value: CLINIC_OPTIONS.CLINIC_FAX_NUMBER
    },
    {
      title: "Clinic - Google Map URL",
      value: CLINIC_OPTIONS.CLINIC_GOOGLE_MAP_URL
    },
    {
      title: "Clinic - Business Name",
      value: CLINIC_OPTIONS.CLINIC_BUSINESS_NAME
    },
    {
      title: "Practice - Portal Link",
      value: CLINIC_OPTIONS.PRACTICE_PORTAL_LINK
    },
    {
      title: "Clinic - Street Address",
      value: CLINIC_OPTIONS.CLINIC_STREET_ADDRESS
    },
    {
      title: "Clinic - City, State ZIP",
      value: CLINIC_OPTIONS.CLINIC_CITY_STATE_ZIP
    },
    {
      title: "Clinic - Billing Street Address",
      value: CLINIC_OPTIONS.CLINIC_BILLING_STREET_ADDRESS
    },
    {
      title: "Clinic - Billing City, State ZIP",
      value: CLINIC_OPTIONS.CLINIC_BILLING_CITY_STATE_ZIP
    },
    {
      title: "Clinic - Billing Full Address",
      value: CLINIC_OPTIONS.CLINIC_BILLING_FULL_ADDRESS
    },
    {
      title: "Clinic - Billing Phone Number",
      value: CLINIC_OPTIONS.CLINIC_BILLING_PHONE_NUMBER
    },
    {
      title: "Practice - NPI",
      value: CLINIC_OPTIONS.PRACTICE_NPI
    }
  ]
};
